<template>
  <v-autocomplete 
    v-model="valor" 
    :label="label"
    :clearable="clearable"
    :items="items"
    item-text="denominacionProvincia"
    item-value="codigoProvincia"
    :loading="loading"
    :rules="(items.length > 0) ? [rules.required] : []"
    :disabled="disabled || loading || codigoLlamada === -1"
    :readonly="readonly"
    browser-autocomplete="OVERPRESELECT"
  />
</template>
<script>
import rules from '@/mixins/rules'
export default {
  mixins: [rules],
  props: {
    codigo: {
      type: String,
      default: 'codigo'
    },
    llamada: {
      type: Function
    },
    label: {
      type: String
    },
    value: {},
    codigoLlamada: {},
    disabled: {
      type: Boolean,
      default: false
    },
    readonly: {
      type: Boolean,
      default: false
    },
    clearable: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      loading: false,
      items: []
    }
  },
  async created () {
    try {
      this.realizarLlamada()
    } catch (error) {
      console.log(error)
    }
  },
  computed: {
    valor: {
      get () {
        return this.value
      },
      set (v) {
        this.$emit('input', v != null ? this.items.find(x => x[this.codigo] === v)[this.codigo] : null)
      }
    }
  },
  methods: {
    async realizarLlamada () {
      if (this.codigoLlamada != null) {
        this.items = await this.llamada(this.codigoLlamada)
      } else {
        this.items = []
      }
    }
  },
  watch: {
    async codigoLlamada (newVal) {
      if (newVal != null) {
        this.loading = true
        await this.realizarLlamada()
        if (this.items.find(x => x[this.codigo] === this.value) == null) {
          this.$emit('input', null)
        }
        this.loading = false
      } else {
        this.$emit('input', null)
        this.items = []
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/generic/SelectPreLoadItem.vue